var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-sm-block border-right border-left",attrs:{"id":"stick","title":_vm.size + '%'},on:{"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp}})}
var staticRenderFns = []

export { render, staticRenderFns }